module.exports = __webpack_public_path__ + "img/tg_01 (3).09bcbb68.jpg";